import styled from 'styled-components';

export const Container = styled.span<{ $isLoading: boolean }>`
  display: flex;
  max-width: 276px;
  height: 26px;
  border: 1px solid #57b357;
  border-radius: 4px;
  border-top-left-radius: 0;
  font-size: 12px;
  line-height: 14px;
  color: #006400;
  justify-content: center;
  align-items: center;
  margin: 10px 0 0 6px;
  position: relative;
  padding: 0 10px;
  white-space: nowrap;
  ${({ $isLoading }) => $isLoading && 'opacity: 0;'};

  @media screen and (max-width: 768px) {
    margin: 10px 10px 0 10px;
  }

  &::before,
  &::after {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
  }

  &::before {
    border-width: 8px 0 0 8px;
    border-color: transparent transparent transparent #57b357;
    top: -8px;
    left: -1px;
  }

  &::after {
    border-width: 7px 0 0 7px;
    border-color: transparent transparent transparent #ffffff;
    top: -6px;
    left: 0;
  }
`;
